export const ContactType = {
    associate: 'Associate',
    driver: 'Driver',
    newDriver: 'Add Driver',
};
